import { Breakpoint } from '@philips-emr/tws-constants';
import { Value } from '@philips-emr/tws-core';
import { Validation } from '@philips-emr/tws-core/lib/services/model-service';
import { getBreakpoint } from '@philips-emr/tws-utils';

const CONFIRMATION_FIELD_VALID = 'confirmationField';
const PW_VALIDATOR = 'passwordValidator';
const SENHA_NOVA_DIFERENTE_ATUAL = 'senhaNovaDiferenteDaAtual';
const NOT_RENDERED_COMPONENT_APIS = 'You should not access not rendered component apis.';

const PW = /^(?=.*?[A-Z])(?=(.*[a-z]))(?=(.*[\d]))(?=(.*[\W_])).{8,}$/;

function confirmationFieldValidator(value: Value, confirmationValue: Value): Validation[] {
  const valid = Boolean(value) && Boolean(confirmationValue) && confirmationValue === value;

  return [{
    message: !valid ? 'provider.different-from-previous' : '',
    name: CONFIRMATION_FIELD_VALID,
    valid,
  }];
}

function passwordValidator(value: Value): Validation[] {
  const pass = value as string || '';
  const valid = Boolean(RegExp(PW).exec(pass)) && pass.length >= 8 && pass.length <= 16;

  return [{
    message: !valid ? 'provider.password-rules' : '',
    name: PW_VALIDATOR,
    valid,
  }];
}

function catchRenderException(arg: () => void, defaultValue?: any): any {
  try {
    return arg();
  } catch (e) {
    const { message } = e as Error;
    const ignoreErr = [NOT_RENDERED_COMPONENT_APIS];
    if (!ignoreErr.includes(message)) {
      console.error(e);
    }
    return defaultValue;
  }
}

function shouldRenderMobile(): boolean {
  const breakpoint = getBreakpoint();
  return breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
}

export {
  catchRenderException,
  CONFIRMATION_FIELD_VALID,
  PW_VALIDATOR,
  SENHA_NOVA_DIFERENTE_ATUAL,
  shouldRenderMobile,
};

export {
  confirmationFieldValidator,
  passwordValidator,
};
